module.exports = __webpack_public_path__ + "img/sbd.edcf1eca.svg";